import React from 'react';
import {styled} from '@volkswagen-onehub/components-core';
import {ShowroomTopbarNavigationModel} from '../../../../generated/core';
import {CmsPlainLink} from '../../../components/links/CmsPlainLink';
import {useContentStore} from '../../../context';
import {useCurrentOrLastPageRootModel} from './useCurrentOrLastPageRootModel';
import {observer} from 'mobx-react-lite';

export interface ShowroomTopbarNavigationProps {
    model: ShowroomTopbarNavigationModel;
}

const StyledNav = styled.nav`
    display: flex;
    gap: ${props => props.theme.size.static150};
`;

const StyledNavItem = styled.span<{active?: boolean}>`
    a {
        position: relative;
        white-space: nowrap;
        display: flex;
        padding: ${props => props.theme.size.static150};

        color: ${({theme}) => theme.colors.tab.default};

        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: ${props => props.theme.size.static150};
            right: ${props => props.theme.size.static150};
            height: 0;
            background: ${({theme}) => theme.colors.tab.default};
        }

        &:hover {
            color: ${({theme}) => theme.colors.tab.hover};

            &::after {
                background: ${({theme}) => theme.colors.tab.hover};
                height: 1px;
            }
        }

        &:focus {
            color: ${({theme}) => theme.colors.tab.hover};
            outline: solid 2px;
            outline-offset: 3px;

            &::after {
                background: ${({theme}) => theme.colors.tab.hover};
            }
        }

        ${props =>
            props.active &&
            `
            font-weight: bold;

            ::after,
            &:hover::after {
                height: 2px;
            }
        `}
    }
`;

export const ShowroomTopbarNavigation = observer(function STN() {
    const pageRootModel = useContentStore().getCurrentPageRootModel();

    const currentOrLastPageRootModel =
        useCurrentOrLastPageRootModel(pageRootModel);

    const model = currentOrLastPageRootModel?.showroomTopbarNavigationModel;

    if (!model || !model.items) {
        return undefined;
    }

    return (
        <div data-cy="showroomNavigation">
            <StyledNav>
                {model.items?.map(item => {
                    return (
                        <StyledNavItem key={item.path} active={item.selected}>
                            <CmsPlainLink
                                key={item.path}
                                href={item.path}
                                disabled={item.selected}
                            >
                                {item.title}
                            </CmsPlainLink>
                        </StyledNavItem>
                    );
                })}
            </StyledNav>
        </div>
    );
});
